import {styled} from '@linaria/react';
import {WishButton} from '../WishButton/WishButton';

export const ProductTileWishlistButton = styled(WishButton)`
  &&& {
    width: 24px;
    height: 24px;
    transition: opacity 300ms ease-in;
    background: none;
    margin-inline: 6px;
  }
`;
